export const vacancyFiltersAdapter = (data: any) => {
  return data.map((item) => {
    const { name, id } = item
    return {
      name,
      value: String(id),
    }
  })
}
